module.exports = __webpack_public_path__ + "static/media/guide_img1_4_m.c4855558.png";